import React, { useState, useEffect } from "react";
import Select, { ActionMeta, MultiValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import CreatableSelect from 'react-select/creatable';

import index from "@beeldit/core/services";
import { Room } from "../models/Room";

interface Option {
  label: string;
  value: number | string;
}

function MultiSelector(props: any) {
  const { id, value, required, disabled, readonly, onChange, formContext } =
    props;
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(
    []
  );
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const errorHandler = useErrorHandler();

  const { element, setElement } = formContext;

  useEffect(() => {    
    if (!element.start_date_time || !element.end_date_time) {
      setElementsData({ elements: [] });
      setElement({ ...element, rooms: [] });
    } else {
      // creamos una variable con start_date_time and end_date_time y si selectedOptions es diferente de null añadimos los ids de las habitaciones seleccionadas separados por comas
      const queryParams = {
        start_date_time: element.start_date_time,
        end_date_time: element.end_date_time,
        // selected: element.id ? value.map((v: any) => v).join(",") : "",
        selected: value.map((v: any) => v).join(",")
      };
      // Convertimos queryParams a string
      const queryString = new URLSearchParams(queryParams).toString();
      index("rooms", queryString)
        .then((response: any) => {
          setElementsData(response.data);
        })
        .catch((error: any) => {
          errorHandler(error, null);
        });
    }
  }, [element.start_date_time, element.end_date_time]);

  useEffect(() => {
    const options = elementsData.elements.map((room: Room) => {
      return { label: room.name, value: room.id };
    });
    setOptions(options);
    const currentSelectedOptions = options.filter((option) => {
      if (value && value.includes(option.value)) {
        return true;
      }
    });
    setElement({
      ...element,
      rooms: currentSelectedOptions.map((option) => option.value),
    });
    setSelectedOptions(currentSelectedOptions);
  }, [elementsData]);

  const handleOnChange = (
    newValue: MultiValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    setSelectedOptions(newValue);
    const model = newValue.map((option) => {
      return option.value;
    });
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <>
      <CreatableSelect
        id={id}
        isMulti
        options={options}
        value={selectedOptions}
        required={required}
        isDisabled={disabled || readonly}
        onChange={handleOnChange}
        styles={selectStyles}
      />
    </>
  );
}

function RoomsSelector(props: any) {
  const {
    id,
    options,
    value,
    required,
    disabled,
    readonly,
    onChange,
    formContext,
  } = props;
  return (
    <MultiSelector
      id={id}
      options={options.enumOptions}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
      formContext={formContext}
    />
  );
}

export default RoomsSelector;
